import { ToggleButton, ToggleButtonProps } from '@mui/material';
import React, { FormEvent } from 'react';
import { useSlate } from 'slate-react';
import { isBlockActive } from '../../helpers';
import { toggleBlock } from '../../transformers';
import { BlockType } from '../../types';

// 'Block' element toggle button
type BlockButtonProps = { blockType: BlockType; value?: string } & ToggleButtonProps;
export const BlockButton = ({
	blockType,
	value = blockType,
	children,
	...props
}: BlockButtonProps) => {
	const editor = useSlate();

	const handleMouseDown = (event: FormEvent<HTMLButtonElement>) => {
		event.preventDefault();
		toggleBlock(editor, blockType);
	};

	return (
		<ToggleButton
			size='small'
			value={value}
			selected={isBlockActive(editor, blockType)}
			onMouseDown={handleMouseDown}
			{...props}
		>
			{children}
		</ToggleButton>
	);
};
